import { Para, Stack } from 'ui-components';
import { Controller } from 'react-hook-form';
import ControlledSelectInput from './ControlledSelectInput';
import { Parting } from 'drycut-graphql';
import ControlledCheckboxInput from './ControlledCheckboxInput';

export function CommonOptions(): JSX.Element {
  const Partings: Record<Parting, string> = {
    [Parting.NotDefined]: '—',
    [Parting.Left]: 'links',
    [Parting.Middle]: 'Mitte',
    [Parting.Right]: 'rechts',
  };

  const partingOptions = Object.keys(Partings).map((key) => ({
    value: key,
    label: Partings[key as Parting],
  }));

  return (
    <Stack gap={2} className="w-full">
      <Stack direction="row" className="w-full flex justify-between items-center min-h-10">
        <Para as="label" htmlFor="cutEyebrows">
          Augenbrauen kürzen
        </Para>

        <ControlledCheckboxInput name="cutEyebrows" />
      </Stack>

      <Stack direction="row" className="w-full flex justify-between">
        <Para as="label" htmlFor="parting">
          Scheitel
        </Para>

        <ControlledSelectInput name="parting" options={partingOptions} />
      </Stack>

      <Controller
        name="notes"
        render={({ field }) => (
          <textarea
            {...field}
            className="w-full h-32 resize-none bg-transparent border border-zinc-300 p-2 focus:ring-primary-300 focus:ring-2 focus:border-zinc-300"
            placeholder="Sonstige Hinweise, die hilfreich für die Stylistin sein könnten. Beispiel: Im Zweifel immer etwas länger lassen"
          />
        )}
      />
    </Stack>
  );
}
